export const ParserType = {
    OPLUS: "OPLUS",
    RUFUS: "RUFUS",
    OPHTIX: "OPHTIX",
}